export const getInitialState = (): any => ({
  snowflakePushDataProgressData: {}
});